module.exports = {
    wedrive_main_url: 'https://wedrive-dev.vbote.com',
    wedrive_service_url: 'https://apps.wemob.es/WMServices/',
    wedrive_gtag_id: 'G-J2QJ1066GS',
version : '1.0.123' ,
};